import { FaCheckCircle } from "react-icons/fa";
import { RiFileCheckFill, RiFileCloseFill } from "react-icons/ri";
import { useEffect, useState } from "react";

import { CentsToHuman, customDateTimeFormat } from "../../utils";
import Style from "./CreditAnalysisTableStyle";
import PageTitle from "../../components/PageTitle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";
import { IoCloseCircle } from "react-icons/io5";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";

export interface CreditAnalysisModel {
  id: number,
  orderId: number,
  approved: boolean,
  userName: string,
  userEmail: string,
  apartmentNumber: string,

  paymentOption: string,
  installments: number,
  installmentPrice: string,
  createdAt: string,
}

export default function CreditAnalysisTable() {
  const [loading, setLoading] = useState(false);
  const [creditAnalyses, setCreditAnalyses] = useState<CreditAnalysisModel[]>();
  const [approving, setApproving] = useState(false);

  const [creditToApprove, setCreditToApprove] = useState<CreditAnalysisModel>();
  const [showPopup, setShowPopup] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");


  useEffect(() => {
    setLoading(true);
    GetOrders().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function GetOrders() {
    try {
      const creditAnalysisResponse = await api.get("creditAnalysis");
      const analyses = creditAnalysisResponse.data.analyses;
      analyses.sort((a, b) => b.id - a.id);
      setCreditAnalyses(analyses);
      setErrorMessage("");
    } catch (error) {
      console.error(error);
      setErrorMessage("Não foi possível carregar análises, erro " + error);
    }
  }


  async function approveAnalysis(creditAnalysis: CreditAnalysisModel | undefined) {
    if (!creditAnalysis || creditAnalysis.approved)
      return;

    try {
      setApproving(true);
      const result = await api.put(`creditAnalysis/${creditAnalysis.id}/approve`);

      setSuccessMessage("Aprovou crédito com sucesso de " + result.data.analysis.userName);
      setErrorMessage("");
      onClosePopup();
      GetOrders().then(() => {
        setLoading(false);
      });
    }
    catch (error: any) {
      setLoading(false);
      onClosePopup();
      setErrorMessage(error?.response?.data?.message);
    }
    finally {
      setShowPopup(false);
      setApproving(false);
    }
  }

  function onClickApproveAnalysis(creditAnalysis: CreditAnalysisModel) {
    setCreditToApprove(creditAnalysis);
    setShowPopup(true);
  }

  function onClosePopup() {
    setCreditToApprove(undefined);
    setShowPopup(false);
  }

  return (
    <Style>
      <PageTitle title="Análises de créditos" />
      <Spinner spinning={loading} />
      <TwoButtonsModal
        show={showPopup && creditToApprove != null}
        onHide={onClosePopup}
        loading={loading || approving}
        title="Aprovação de crédito!"
        body="Você tem certeza que deseja aprovar crédito?"
        secondaryText="Fechar"
        secondaryOnClick={onClosePopup}
        secondaryDisabled={loading || approving}
        primaryText="Confirmar"
        primaryOnClick={() => approveAnalysis(creditToApprove)}
        primaryDisabled={loading || approving}
      />

      {errorMessage && <p className="alert alert-danger">Erro: {errorMessage}</p>}
      {successMessage && <p className="alert alert-info">{successMessage}</p>}


      <section className="table-title">
        <h1>Análises de créditos</h1>
      </section>
      {errorMessage && <h1 className="alert alert-error"> {errorMessage}</h1>}
      <table className="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Pedido</th>
            <th>Cliente</th>
            <th>Apartamento</th>
            <th>Pagamento</th>
            <th>Parcelas</th>
            <th>Valor parcela</th>
            <th>Data da análise</th>
            <th>Aprovado</th>
            <th>Ação</th>

          </tr>
        </thead>
        <tbody>
          {creditAnalyses?.length ?
            creditAnalyses.map((ca) => {
              return (
                <tr key={ca.id}>
                  <td>{ca.orderId}</td>
                  <td>{ca.userName}</td>
                  <td>{ca.apartmentNumber}</td>
                  <td>{ca.paymentOption}</td>
                  <td>{ca.installments}</td>
                  <td>{CentsToHuman(parseInt(ca.installmentPrice))}</td>
                  <td>{customDateTimeFormat(ca.createdAt)}</td>
                  <td>
                    <div className="center">
                      {ca.approved ? <RiFileCheckFill /> : <RiFileCloseFill />}
                    </div>
                  </td>
                  <td onClick={() => onClickApproveAnalysis(ca)} className={ca.approved ? "" : "clickable"}>
                    <div className="action">
                      {ca.approved ?
                        <IoCloseCircle className="icon-action-disabled" /> :
                        <FaCheckCircle className="icon-action" />
                      }
                    </div>
                  </td>
                </tr>
              );
            }) : <p>Sem análises</p>
          }
        </tbody>
      </table>
    </Style>
  );
}
